import React from 'react';
import { Card, Row, Col, Statistic, Empty, Divider } from 'antd';

const InvoiceBreakdown = ({ data, loading }) => {
  if (loading || !data || !data.invoices) {
    return null;
  }

  const { invoices } = data;

  if (invoices.total_count === 0) {
    return (
      <Card title="Invoice Breakdown" style={{ marginBottom: 24 }}>
        <Empty description="No invoices yet" />
      </Card>
    );
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  };

  const periods = invoices.periods || [];
  const monthlyData = invoices.by_month || [];
  const colors = ['#1890ff', '#52c41a', '#fa8c16', '#722ed1'];

  return (
    <Card title="Invoice Breakdown" style={{ marginBottom: 24 }}>
      {periods.length > 0 && (
        <div>
          <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Time Period</h3>
          <Row gutter={[16, 16]}>
            {periods.map((period, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card
                  size="small"
                  style={{
                    textAlign: 'center',
                    borderTop: `3px solid ${colors[index % colors.length]}`,
                  }}
                >
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>
                      {period.title}
                    </div>
                    <Statistic
                      value={period.count}
                      valueStyle={{ 
                        fontSize: 32, 
                        color: colors[index % colors.length], 
                        fontWeight: 'bold' 
                      }}
                      suffix="invoices"
                    />
                  </div>
                  <div style={{ fontSize: 16, color: '#666', marginTop: 8 }}>
                    {formatCurrency(period.value)}
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}

      {monthlyData.length > 0 && (
        <div>
          <Divider />
          <h3 style={{ marginBottom: 16, fontSize: 16, fontWeight: 500 }}>By Month (Last 12 Months)</h3>
          <Row gutter={[16, 16]}>
            {monthlyData.map((month, index) => (
              <Col xs={12} sm={8} lg={6} xl={4} key={index}>
                <Card
                  size="small"
                  style={{
                    textAlign: 'center',
                    borderTop: '2px solid #722ed1',
                  }}
                >
                  <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 4 }}>
                    {month.month}
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 'bold', color: '#722ed1' }}>
                    {month.count}
                  </div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                    {formatCurrency(month.value)}
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </Card>
  );
};

export default InvoiceBreakdown;
